















































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import  ItemContent  from './item-content.vue';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { currentUserKey } from '@/shared/msw-constants';
import * as decode from 'jwt-decode';

const cssPrefix = 'create-customer';

@Component({
  components: {
    ItemContent,
    SwButton,
    SwModalBody,
    SwScrollView,
    SwTextfield,
    SwCheckbox,
    SwIcon,
  },
})
export default class CreateCustomer extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  startIndex = 0;
  endIndex = 0;
  @Prop({ type: Array })
  customersList: any;

  @Prop({ type: Array, required: true })
  selectedCustomer: any;

  @Prop({ type: Boolean, default: true })
  enableAddButton: boolean;

  @Prop({ type: Array, required: false })
  selectedListItems: any;

  @Prop({ type:Boolean, default: false })
  assignCustomerMode: boolean;

  @Prop({ type :Boolean, default: false })
  createCustomerMode: boolean;

  @Prop()
  selectedUserGroup: any;

  filteredCustomersInDialog: any[] = [];
  selectedCustomersInDialog: any = [];
  unSelectedCustomersInDialog: any = [];
  searchCustomerString: string = '';
  organizationId: string = '';

  created() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained && userInfoObtained.token) {
      const decodedToken: any = decode(userInfoObtained.token);
      this.organizationId = decodedToken?.orgid || '';
    }
  }

  mounted() {
    this.selectedCustomersInDialog = [...this.selectedCustomer];
    this.unSelectedCustomersInDialog = [...this.customersList];
    this.searchCustomerString = '';
    if (this.$store.getters.isLargeCustomer) {
      this.startIndex = 0;
      this.endIndex = Math.min(this.customersList.length, 50);
      this.filteredCustomersInDialog = this.customersList.slice(this.startIndex, this.endIndex);
      console.warn(this.startIndex);
      console.warn(this.endIndex);
    } else {
      this.filteredCustomersInDialog = [...this.customersList];
    }
    // this.filteredCustomersInDialog = this.filteredCustomersInDialog.filter((ele: any) => {
    //   return this.filterMsspEntries(ele);
    // });
  }

  // filterMsspEntries(entry: any) {
  //   const key: string = 'msspId';
  //   Disabled check for msspId
  //   return (entry[key] === '' || entry[key] === undefined) ? true : true;
  // }

  get disableAddButton() {
    return this.selectedCustomersInDialog.length === 0;
  }

  get getFilteredCustomersInDialog() {
    if (this.organizationId) {
      return this.filteredCustomersInDialog.filter((customer: any) => {
        return customer.orgID  === this.organizationId;
      });
    }
    return this.filteredCustomersInDialog;
  }

  searchCustomers() {
    if (this.searchCustomerString !== '') {
      this.filteredCustomersInDialog = this.unSelectedCustomersInDialog.filter((list: any) => list.productGroupName.toLocaleLowerCase()
      .includes(this.searchCustomerString.toLocaleLowerCase()
      .trimRight()));
    } else {
      if (this.$store.getters.isLargeCustomer) {
        this.filteredCustomersInDialog = this.unSelectedCustomersInDialog.slice(this.startIndex, this.endIndex);
      } else {
        this.filteredCustomersInDialog = [...this.unSelectedCustomersInDialog];
      }
    }

    // this.filteredCustomersInDialog = this.filteredCustomersInDialog.filter((ele: any) => {
    //   return this.filterMsspEntries(ele);
    // });
  }

  onAvailableCustomers(productGroupId: number) {
    const indexOfCustomer = this.filteredCustomersInDialog.findIndex(item => item.productGroupId === productGroupId);
    const selectedCustomer = this.filteredCustomersInDialog.splice(indexOfCustomer, 1)[0];
    this.selectedCustomersInDialog.push(selectedCustomer);
    this.unSelectedCustomersInDialog.splice(this.unSelectedCustomersInDialog.indexOf(selectedCustomer), 1);
    this.assignCustomerMode && this.emitSelectedCustomers(); // For Assign Customer Dialog
  }

  addCustomers() {
    const listCompator = this.$store.getters['MswUserGroupStoreModule/getInitialCustomersList'];
    const changedList = this.selectedCustomersInDialog.map((ele : any) => ele.productGroupName);
    if (JSON.stringify(listCompator) !== JSON.stringify(changedList.sort())) {
      this.emitSelectedCustomers();
      this.modalClose();
    }
  }

  onSelectedCustomer(index: number) {
    const selectedCustomer = this.selectedCustomersInDialog.splice(index, 1)[0];
    this.filteredCustomersInDialog.push(selectedCustomer);
    this.unSelectedCustomersInDialog.push(selectedCustomer);
    this.assignCustomerMode && this.emitSelectedCustomers(); // For Assign Customer Dialog
  }

  emitSelectedCustomers() {
    this.$emit('selectedCustomersList', this.selectedCustomersInDialog);
  }
  modalClose() {
    this.$emit('request-close');
  }
  handleScroll(e : any) {
    if (e.srcElement && (e.srcElement.scrollHeight - e.srcElement.scrollTop - e.srcElement.clientHeight < 1) && this.$store.getters.isLargeCustomer) {
      console.warn('hit bottom');
      const offSet = Math.min(this.customersList.length, this.endIndex + 20);
      for (let i = this.endIndex ; i < offSet ; i += 1) {
        this.filteredCustomersInDialog.push(this.customersList[i]);
      }
      this.endIndex = offSet;
      console.warn(this.endIndex);
      console.warn(this.startIndex);
    }
  }
}
